<template>
  <div>
    <NavBar />
    <div class="container">
      <div class="row d-print-none">
        <div v-if="!redirecting" class="col">
          <h1>No Access</h1>
          <p>Your organization has not provisioned your access.</p>
          <p>Please contact your organization administrator or Verensics support to provision your access.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import NavBar from "@/views/reports/NavBar.vue";

export default {
  components: {
    NavBar,
  },
  data() {
    return {
      redirecting: true,
    };
  },
  async created() {
    if (this.isVerensicsAdministrator) {
      this.$router.push(`/organizations`);
      return;
    }

    if (this.hasReports && this.hasReportRoles && !this.isInvestigationProctor) {
      this.$router.push(`/organizations/${this.organization.id}/reports`);
      return;
    }

    if (this.hasInvestigations && this.hasInvestigationRoles) {
      this.$router.push(`/organizations/${this.organization.id}/investigations`);
      return;
    }

    this.redirecting = false;
  },
  computed: {
    ...mapGetters("organization", ["organization"]),
    ...mapGetters("user", ["user"]),
    ...mapGetters("feature", ["hasReports", "hasInvestigations"]),
    ...mapGetters("role", [
      "isVerensicsAdministrator",
      "isOrganizationAdministrator",
      "isReportSummary",
      "isReportCreator",
      "isReportViewer",
      "isReportCommenter",
      "isInvestigationCreator",
      "isInvestigationSummary",
      "isInvestigationViewer",
      "isInvestigationProctor",
    ]),
    hasReportRoles() {
      return this.isOrganizationAdministrator || this.isReportSummary || this.isReportCreator || this.isReportViewer || this.isReportCommenter;
    },
    hasInvestigationRoles() {
      return (
        this.isOrganizationAdministrator ||
        this.isInvestigationCreator ||
        this.isInvestigationSummary ||
        this.isInvestigationViewer ||
        this.isInvestigationProctor
      );
    },
  },
};
</script>
